import { Injectable } from '@angular/core';
import { DeveloperInsight } from 'app/models/DeveloperInsight';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DeveloperStateService {
  private developerSubject = new BehaviorSubject<DeveloperInsight | null>(null);

  developer$ = this.developerSubject.asObservable();

  setDeveloper(developer: DeveloperInsight) {
    this.developerSubject.next(developer);
  }

  getDeveloper(): DeveloperInsight | null {
    return this.developerSubject.getValue();
  }
}
